module.exports = __webpack_public_path__ + "static/media/cert_100001.16668975.jpg";